import {
  FETCH_FAILED_PAYMENTS_LIST,
  FETCH_CITY,
  RETRY_FAILED_PAYMENTS,
} from './endpoint-constants';

const getCityOptions = countryCode => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${FETCH_CITY}?countryCode=${countryCode}`;
};

const failedPaymentsListEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;

  return `${geAPIV2}${FETCH_FAILED_PAYMENTS_LIST}`;
};

const retryfailedPaymentsEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;

  return `${geAPIV2}${RETRY_FAILED_PAYMENTS}`;
};

export default {
  getCityOptions,
  failedPaymentsListEpt,
  retryfailedPaymentsEpt,
};
